// extracted by mini-css-extract-plugin
export default {"scoreNotExist":"k1i8hE61sIE00GO1xU5b","badScore":"wXTdcaNuvkazM1yB_Hv9","goodScore":"jLU5wsm0Vrwdv2Xs6XLx"};